module.exports = __webpack_public_path__ + "img/phone-icon.06a63d9b.svg";